'use strict';
const clientVersion = require('../../../package.json').version;

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.about', {
        url: '/about',
        templateUrl: 'app/about/about.html',
        controller: function() {
          this.clientVersion = clientVersion;
        },
        controllerAs: '$ctrl'
      });
  });